<template>
  <b-button
    class="rent-info-box"
    variant="primary"
    style="width: 90%; padding: 5%: margin-top:5%"
    @click="handleClick"
    :disabled="loading"
  >
    <span v-if="loading">Atualizando...</span>
    <span v-else>Atualizar valores</span>
  </b-button>
</template>

<script>
import { BButton } from "bootstrap-vue";
import axios from "axios";
import { DateTime } from "luxon";

export default {
  props: {
    selectedDate: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async fetchLiquidation(date) {
      const BASE_URL = process.env.VUE_APP_BASE_URL_THOTH;
      const API_KEY = process.env.VUE_APP_API_KEY_THOTH;
      const formattedDate = DateTime.fromISO(date).toFormat("yyyy-MM-dd");

      const response = await axios.post(
        `${BASE_URL}liquidation-veripag`,
        {
          initialdate: formattedDate,
          finaldate: formattedDate,
        },
        { headers: { "Api-Key": API_KEY } }
      );
      return response;
    },
    async fetchLExtract(date) {
      const BASE_URL = process.env.VUE_APP_BASE_URL_THOTH;
      const API_KEY = process.env.VUE_APP_API_KEY_THOTH;
      const formattedDate = DateTime.fromISO(date).toFormat("yyyy-MM-dd");

      const response = await axios.post(
        `${BASE_URL}extract-veripag`,
        {
          initialdate: formattedDate,
          finaldate: formattedDate,
        },
        { headers: { "Api-Key": API_KEY } }
      );
      return response;
    },
    async handleClick() {
      this.loading = true;
      try {
        await Promise.all([
          this.fetchLiquidation(this.selectedDate),
          this.fetchLExtract(this.selectedDate),
        ]);
        this.$emit("success");
      } catch (err) {
        console.error("Erro ao atualizar valores:", err);
        this.$emit("error", err);
      } finally {
        this.loading = false;
      }
    },
  },
  components: { BButton },
};
</script>
